import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import i18n from '~/i18n';
import {
  AwsDateTimeFilter,
  QuestionInput,
  QuestionnaireWhereInput,
  QuestionType,
} from '~/models/common';

dayjs.extend(utc);

const { t } = i18n;
export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const getQuestionInfo = (type): QuestionInput | null => {
  const question = {
    type,
    content: t(`questionnaire.create.questionType.placeholder.${type}`),
    isRequired: false,
    isShowExplain: false,
    explain: '',
  };
  switch (type) {
    case QuestionType.RadioSelection:
    case QuestionType.CheckboxSelection:
    case QuestionType.SelectSelection:
      return {
        ...question,
        answers: [
          {
            content: `${t(
              'questionnaire.create.questionType.placeholder.option',
              { key: 1 },
            )}`,
            order: 0,
          },
          {
            content: `${t(
              'questionnaire.create.questionType.placeholder.option',
              { key: 2 },
            )}`,
            order: 1,
          },
        ],
      };

    case QuestionType.Text:
    case QuestionType.TextArea:
      return {
        ...question,
        answers: [
          {
            content: t('questionnaire.create.formCreate.inputAnswer'),
            order: 0,
          },
        ],
      };
    case QuestionType.Matrix:
      return {
        ...question,
        groupAnswers: [
          {
            title: t('questionnaire.create.formCreate.matrixGroup', {
              key: `${ALPHABET.charAt(0)}`,
            }),
            order: 1,
            answers: [
              {
                content: t('questionnaire.create.formCreate.good'),
                order: 1,
              },
              {
                content: t('questionnaire.create.formCreate.bad'),
                order: 2,
              },
            ],
          },
          {
            title: t('questionnaire.create.formCreate.matrixGroup', {
              key: `${ALPHABET.charAt(1)}`,
            }),
            order: 2,
            answers: [
              {
                content: t('questionnaire.create.formCreate.good'),
                order: 1,
              },
              {
                content: t('questionnaire.create.formCreate.bad'),
                order: 2,
              },
            ],
          },
        ],
      };
    case QuestionType.Rating:
      return {
        ...question,
        answers: [
          { content: '0', order: 0 },
          { content: '1', order: 1 },
          { content: '2', order: 2 },
          { content: '3', order: 3 },
          { content: '4', order: 4 },
        ],
        highlyRatingLabel: t('questionnaire.create.formCreate.good'),
        lowRatingLabel: t('questionnaire.create.formCreate.bad'),
      };
    default:
      return null;
  }
};

export const convertFilters = (values: any): QuestionnaireWhereInput => {
  if (!values) return {};

  const { title, createdAt, category, status } = values;

  return {
    status: status ?? undefined,
    category: category ?? undefined,
    title: title !== undefined ? { contains: title } : undefined,
    createdAt: Array.isArray(createdAt)
      ? ({
          gte: createdAt[0]
            ? dayjs.utc(createdAt[0]).startOf('day').toISOString()
            : undefined,
          lte: createdAt[1]
            ? dayjs.utc(createdAt[1]).endOf('day').toISOString()
            : undefined,
        } as AwsDateTimeFilter)
      : undefined,
  };
};
